import { render, staticRenderFns } from "./Subheading.vue?vue&type=template&id=2cf9f7e8&scoped=true&functional=true"
import script from "./Subheading.vue?vue&type=script&lang=ts"
export * from "./Subheading.vue?vue&type=script&lang=ts"
import style0 from "./Subheading.vue?vue&type=style&index=0&id=2cf9f7e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "2cf9f7e8",
  null
  
)

export default component.exports